// Generated by ts-to-zod
import {z} from "zod";
import {mantineCssStyleRecordSchema} from "./primitives.zod";
import {mantineSpacingSchema} from "./spacing.zod";

export const mantineBoxPropsSchema = z.strictObject({
	p: mantineSpacingSchema.optional(),
	px: mantineSpacingSchema.optional(),
	py: mantineSpacingSchema.optional(),
	pb: mantineSpacingSchema.optional(),
	pt: mantineSpacingSchema.optional(),
	m: mantineSpacingSchema.optional(),
	ml: mantineSpacingSchema.optional(),
	mt: mantineSpacingSchema.optional(),
	style: mantineCssStyleRecordSchema.optional(),
});
